import * as React from 'react';
import { Helmet } from 'react-helmet-async';

/**
 * Headコンポーネント用のPropsです。
 * @interface HeadProps
 */
interface HeadProps {

  /**
   * 書類名
   * @type {string}
   * @memberof HeadProps
   */
  documentName: string;

  /**
   * 説明
   * @type {string}
   * @memberof HeadProps
   */
  discription: string;

}

/**
 * ヘッドコンポーネントです。
 * ページコンポーネントから、titleをpropしています。
 * @returns {JSX.Element} - JSX要素
 */
const Head: React.FC<HeadProps> = ({ documentName, discription }) => {

  return (
    <Helmet>
      <title>{`${documentName} | 電子特殊申請書類作成支援ツール`}</title>
      <meta
        name="description"
        content={discription}
      />
      <meta name="viewport" content="width=device-width,initial-scale=1.0,minimum-scale=1.0"></meta>
    </Helmet>
  )
}

export default Head